import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
  UntypedFormArray,
  FormControl,
  UntypedFormGroup,
  Validators,
  UntypedFormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { shareReplay, take } from 'rxjs/operators';
import { DynamicOptionsComponent } from '../dynamic-options';
import { AUTOMATIONS_MARKETS_SERVICE, Market, MarketsService } from '@galaxy/automata/shared';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-market-options',
  templateUrl: './market-options.component.html',
  styleUrls: ['./market-options.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class MarketOptionsComponent implements OnInit, DynamicOptionsComponent {
  marketOptionsControl: FormControl<string> = new FormControl(null, Validators.required);

  marketOptions$: Observable<Market[]> = this.marketsService.markets$.pipe(take(1), shareReplay(1));

  @Input() initialValue: string;
  selectedValue$ = this.marketOptionsControl.valueChanges;

  constructor(@Inject(AUTOMATIONS_MARKETS_SERVICE) protected readonly marketsService: MarketsService) {}

  ngOnInit(): void {
    if (this.initialValue) {
      this.marketOptionsControl.setValue(this.initialValue);
    }
  }

  getSelectedValue(): string {
    return this.marketOptionsControl?.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.marketOptionsControl];
  }

  isFormValid(): boolean {
    return this.marketOptionsControl.valid;
  }
}
